module.exports = __webpack_public_path__ + "static/media/in-the-beginning-was-the-word.d0c31a21.txt";